import React, { useState, FormEvent } from "react";
import { Link } from "react-router-dom";
import { login, signup } from "../../utils/Api";
import Filler from "../../components/Filler";
import AuthField from "../../components/AuthField";
import Config from "../../Config";

import styles from "./Signup.module.css";

type SignupProps = {
  setToken: (token: string) => void;
};

const Signup: React.FC<SignupProps> = ({ setToken }) => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [apiError, setApiError] = useState<string>(
    Config.NATIVE_ENABLED ? "" : "Signups are temporarily disabled."
  );

  const handleSignup = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setApiError("");

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setApiError("Please enter a valid email address.");
      return;
    }
    if (password !== confirmPassword) {
      setApiError("Passwords do not match.");
      return;
    }

    try {
      await signup(email, password);
      const { data } = await login(email, password);
      setToken(data.access_token);
    } catch (err: any) {
      if (err.response) {
        console.error("Login failed:", err.response.data);
        setApiError(err.response.data.detail || "Login failed");
      } else {
        console.error("Error:", err.message);
        setApiError("An unexpected error occurred.");
      }
    }
  };

  return (
    <>
      <div className="container w-50 mt-5 mb-5">
        <h2>Create an account</h2>

        <div className="w-50 mt-5">
          <form onSubmit={handleSignup}>
            <p className="font-mono text-red-600 text-sm">{apiError}</p>

            <div className="mt-3">
              <label className="form-label">Name</label>
              <input type="text" className="form-control" required />
            </div>

            <div className="mt-3">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" required />
            </div>

            <div className="mt-3">
              <label className="form-label">Passwrod</label>
              <input type="password" className="form-control" required />
            </div>

            <div className="mt-3">
              <label className="form-label">Retype password</label>
              <input type="password" className="form-control" required />
            </div>

            {/* Terms and Conditions */}
            <div className="mt-4 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="termsCheck"
                required
              />
              <label className="form-check-label" htmlFor="termsCheck">
                By signing up, you agree to our{" "}
                <Link
                  to="https://good-actor-cae.notion.site/Terms-of-Service-c9c0ea2c826449eda271541d8d7dfabf?source=copy_link"
                  className="text-decoration-none"
                  target="_blank"
                >
                  Terms & Conditions
                </Link>{" "}
                and{" "}
                <Link
                  to="https://good-actor-cae.notion.site/Privacy-Policy-03183e799c4642618001fc3f88c66229?source=copy_link"
                  className="text-decoration-none"
                  target="_blank"
                >
                  Privacy Policy
                </Link>
                .
              </label>
            </div>
            <button
              type="submit"
              aria-label="Login"
              className={`${styles.primaryButton} btn mt-3 mb-3 text-white w-100`}
            >
              Signup
            </button>
          </form>
          <hr />
          <h2 className="mt-5">Already have an account?</h2>
          <p className="mt-3 text-muted">
            Sign in to access your personalized dashboard, explore advanced
            analytics, and continue transforming your data.
          </p>
          <Link
            className={`${styles.secondaryButton} btn mt-3 mb-3`}
            to="/login"
          >
            Sign in
          </Link>
        </div>
      </div>
    </>
  );
};

export default Signup;
